import styled from 'styled-components';

import SPACES from 'utils/constants/spaces';


const ExtraMarginBlock = styled.div`
  margin-bottom: ${SPACES.XL};
`
export default ExtraMarginBlock;
